import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/logo.png'


const _hoisted_1 = {
  class: "v1-hdr-outer",
  id: "v1headerScroll"
}
const _hoisted_2 = {
  class: "v1-lmd-menu",
  id: "v1MenuOpen"
}
const _hoisted_3 = { class: "menu-hide-desktop" }
const _hoisted_4 = { class: "files-icon" }
const _hoisted_5 = { class: "chat-icon" }
const _hoisted_6 = { class: "v1-lmd-header" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "custom-row" }
const _hoisted_9 = {
  class: "site-logo",
  id: "siteLogo"
}
const _hoisted_10 = { class: "after-login-menu hide-mobile" }
const _hoisted_11 = {
  class: "dashboard-icon",
  id: "dashboardLink"
}
const _hoisted_12 = { class: "files-icon" }
const _hoisted_13 = { class: "chat-icon" }
const _hoisted_14 = { class: "v1-lmd-hdr-right" }
const _hoisted_15 = { class: "header-after-login" }
const _hoisted_16 = { class: "login-user-info" }
const _hoisted_17 = {
  href: "javascript:void(0);",
  id: "profileDropDown"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "hdr-dropdown" }
const _hoisted_20 = { class: "hdr-dropdown-in" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", null, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            class: _normalizeClass(["dashboard-icon", { active: _ctx.$route.path === '/employee/dashboard' }]),
            id: "dashboardLink"
          }, [
            _createVNode(_component_router_link, { to: '/employee/dashboard' }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.constants.DASHBOARD_LINK), 1)
              ]),
              _: 1
            })
          ], 2),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: '/employee/files',
              id: "filesLink",
              class: _normalizeClass({ active: _ctx.$route.path === '/employee/files' })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.constants.FILES_LINK), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: '/employee/chats',
              id: "chatLink",
              class: _normalizeClass({ active: _ctx.$route.path === '/employee/chats' })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.constants.CHAT_LINK), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, { to: '/' }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("img", { src: _imports_0 }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: '/employee/dashboard',
                  class: _normalizeClass({ active: _ctx.$route.path === '/employee/dashboard' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants.DASHBOARD_LINK), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: '/employee/files',
                  id: "filesLink",
                  class: _normalizeClass({ active: _ctx.$route.path === '/employee/files' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants.FILES_LINK), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: '/employee/chats',
                  id: "chatLink",
                  class: _normalizeClass({ active: _ctx.$route.path === '/employee/chats' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.constants.CHAT_LINK), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"v1-menu-icon\"><button id=\"menuClick\"><span class=\"hamb-top\"></span> <span class=\"hamb-mid\"></span><span class=\"hamb-btm\"></span></button></div>", 1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("a", _hoisted_17, [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", { src: _ctx.displayImage }, null, 8, _hoisted_18),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "user-status user-status-active" }, null, -1))
                  ]),
                  _createElementVNode("i", null, _toDisplayString(_ctx.constants.WELCOME_TEXT) + " " + _toDisplayString(_ctx.fullName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: '/employee/profile',
                        id: "profileLink"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.constants.PROFILE_LINK), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                        id: "logoutLink"
                      }, _toDisplayString(_ctx.constants.LOGOUT_LINK), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}